







































































import { Vue, Prop, Component } from "vue-property-decorator";
import { CourseTestPassProgress as ICourseTestPassProgress } from "@/api/models/course-test-pass-progress";

@Component
export default class ListenerTestPassProgress extends Vue {
  @Prop() testPass!: ICourseTestPassProgress;
  @Prop() testTitle?: string;

  get screenWidth() {
    return window.innerWidth;
  }

  goToTestPass() {
    let routeData = this.$router.resolve({
      name: "TestPassResultView",
      params: { testPassId: this.testPass.id }
    });
    window.open(routeData.href, "_blank");
  }
}
